module.exports = __webpack_public_path__ + "static/media/Data_insight_en_mo_1-2.635d1c77.svg";